(function () {
  'use strict';
  function reduce(value) {
    if (!Number.isSafeInteger(value) || value < 1) throw new Error('A positive whole number is required.');
    while (value > 9) value = [...String(value)].reduce((sum, digit) => sum + Number(digit), 0);
    return value;
  }
  function parseDate(value, today = new Date()) {
    const match = String(value).trim().match(/^(\d{1,2})\s*([/.\-])\s*(\d{1,2})\s*\2\s*(\d{4})$/);
    if (!match) throw new Error('Enter a full birth date as DD / MM / YYYY.');
    const day = Number(match[1]), month = Number(match[3]), year = Number(match[4]);
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (year < 1 || month < 1 || month > 12 || day < 1 || day > days[month - 1]) throw new Error('Enter a valid calendar date.');
    if (year * 10000 + month * 100 + day > today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate()) throw new Error('A birth date cannot be in the future.');
    const digits = `${String(day).padStart(2, '0')}${String(month).padStart(2, '0')}${String(year).padStart(4, '0')}`;
    const sum = [...digits].reduce((total, digit) => total + Number(digit), 0);
    return { day, month, year, sum, number: reduce(sum) };
  }
  function calculate(first, second, today) {
    const you = parseDate(first, today), partner = parseDate(second, today);
    return { you, partner, number: reduce(you.number + partner.number) };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { reduce, parseDate, calculate };

  if (typeof document === 'undefined') return;
  document.querySelectorAll('[data-compatibility]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const app = root.querySelector('.lc-app');
    const form = root.querySelector('form');
    const chooser = root.querySelector('.lc-love-chooser--date-first');
    const groups = [...root.querySelectorAll('[data-date]')];
    const inputs = [...root.querySelectorAll('[data-part]')];
    const result = root.querySelector('[data-result]');
    const error = root.querySelector('[data-error]');
    const status = root.querySelector('[data-status]');
    const mappingNode = root.querySelector('[data-asset-map]');
    const mapping = mappingNode ? JSON.parse(mappingNode.textContent) : null;
    const dateValue = group => ['day', 'month', 'year'].map(part => group.querySelector(`[data-part="${part}"]`).value.trim()).join('/');
    const imagePath = (number, chapter) => mapping ? mapping[`${number}.${chapter}`] : `${root.dataset.assets}compatibility-${number}-${chapter}.webp`;
    const modal = root.querySelector('[data-lc-partner-cta]');
    const dialog = modal.querySelector('[role="dialog"]');
    let observer = null, shown = false, lastFocus = null, inerted = [], endMarker = null;
    const closeOffer = (restoreFocus = true) => {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('lc-partner-cta-open');
      inerted.forEach(element => { element.inert = false; }); inerted = [];
      app.append(modal);
      if (restoreFocus && lastFocus && lastFocus.isConnected) lastFocus.focus({preventScroll:true});
    };
    const openOffer = () => {
      if (shown || result.hidden) return;
      shown = true;
      if (observer) observer.disconnect();
      lastFocus = document.activeElement;
      // Escape the page's stacking context so the store's sticky header cannot cover the close control.
      document.body.append(modal);
      inerted = [...document.body.children].filter(element => element !== modal && !element.inert && !['SCRIPT','STYLE','LINK'].includes(element.tagName));
      inerted.forEach(element => {element.inert = true;});
      modal.hidden = false;
      document.documentElement.classList.add('lc-partner-cta-open');
      dialog.focus({preventScroll:true});
    };
    modal.querySelectorAll('[data-lc-partner-cta-close]').forEach(button => button.addEventListener('click', () => closeOffer()));
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') {event.preventDefault(); closeOffer(); return;}
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button,a[href]')];
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog)) {event.preventDefault();first.focus();}
    });
    // Also handle a fast scroll directly to the footer, beyond the two-pixel observer target.
    window.addEventListener('scroll', () => {
      if (endMarker && !shown && !result.hidden && endMarker.getBoundingClientRect().top <= window.innerHeight * .92) openOffer();
    }, {passive:true});
    function hideResult() {
      if (observer) observer.disconnect();
      endMarker = null; shown = false; closeOffer(false);
      result.hidden = true; result.classList.remove('is-visible'); result.replaceChildren();
      chooser.hidden = false; status.textContent = '';
    }
    inputs.forEach((input, index) => {
      input.addEventListener('input', event => {
        input.value = input.value.replace(/\D/g, '').slice(0, input.maxLength);
        input.closest('[data-date]').querySelectorAll('input').forEach(field => field.removeAttribute('aria-invalid'));
        error.hidden = true; hideResult();
        if (event.inputType === 'insertText' && input.value.length === input.maxLength && input.selectionStart === input.value.length && inputs[index + 1]) inputs[index + 1].focus();
      });
      input.addEventListener('blur', () => {
        if (input.dataset.part !== 'year' && /^\d$/.test(input.value)) input.value = input.value.padStart(2, '0');
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Backspace' && !input.value && inputs[index - 1]) {event.preventDefault();inputs[index - 1].focus();}
      });
      input.addEventListener('paste', event => {
        const text = event.clipboardData.getData('text').trim();
        const us = text.match(/^(\d{1,2})\s*[/.-]\s*(\d{1,2})\s*[/.-]\s*(\d{4})$/);
        const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!us && !iso) return;
        event.preventDefault();
        const parts = iso ? {year:iso[1],month:iso[2],day:iso[3]} : {month:us[1],day:us[2],year:us[3]};
        const group = input.closest('[data-date]');
        group.querySelectorAll('input').forEach(field => {field.value=parts[field.dataset.part];field.removeAttribute('aria-invalid');});
        error.hidden=true;hideResult();group.querySelector('[data-part="year"]').focus();
      });
    });
    const make = (tag, css, text) => {
      const element=document.createElement(tag);element.className=css;
      if (text !== undefined) element.textContent=text;
      return element;
    };
    form.addEventListener('submit', event => {
      event.preventDefault();hideResult();error.hidden=true;
      inputs.forEach(input => input.removeAttribute('aria-invalid'));
      for (const group of groups) {
        try {parseDate(dateValue(group));}
        catch (failure) {
          const fields=[...group.querySelectorAll('input')];
          fields.forEach(field => field.setAttribute('aria-invalid','true'));
          error.textContent=`${group.dataset.date==='you'?'Your date':'Your partner’s date'}: ${failure.message.replace('DD / MM / YYYY','Month / Day / Year')}`;
          error.hidden=false;(fields.find(field=>!field.value)||fields[0]).focus();return;
        }
      }
      const reading=calculate(dateValue(groups[0]),dateValue(groups[1]));
      result.dataset.number=reading.number;
      const figure=make('figure','lc-result-gallery');
      const bar=make('div','lc-result-gallery__bar');
      const headingWrap=make('div','lc-result-gallery__heading');
      const heading=make('h2','lc-result-gallery__title',`Your relationship carries Compatibility Number ${reading.number}`);
      heading.tabIndex=-1;headingWrap.append(heading);bar.append(headingWrap);figure.append(bar);
      const pages=make('div','lc-result-gallery__pages');
      for (let chapter=1;chapter<=5;chapter++) {
        const article=make('article','lc-result-gallery__chapter');
        article.style.setProperty('--lc-gallery-order',String(chapter-1));
        const badge=make('span','lc-result-gallery__chapter-number',String(chapter).padStart(2,'0')+' / 05');
        const image=make('img','lc-result-gallery__image');
        image.alt=`Illustrated compatibility reading for number ${reading.number}, chapter ${chapter} of 5`;
        image.width=1024;image.height=1536;image.decoding='async';image.loading=chapter===1?'eager':'lazy';
        image.addEventListener('error',()=>article.append(make('p','lc-image-error','This chapter could not load. Please refresh to try again.')),{once:true});
        image.src=imagePath(reading.number,chapter);article.append(badge,image);pages.append(article);
      }
      figure.append(pages);
      endMarker=make('span','lc-result-gallery__end');endMarker.setAttribute('data-lc-gallery-end','');endMarker.setAttribute('aria-hidden','true');figure.append(endMarker);
      figure.append(make('figcaption','visually-hidden',`Five illustrated chapters for compatibility number ${reading.number}. Your full birth-date numbers are ${reading.you.number} and ${reading.partner.number}; their sum reduces to ${reading.number}.`));
      result.append(figure);
      const reset=make('button','lc-result-reset','Calculate again');reset.type='button';reset.setAttribute('data-lc-reset','');
      reset.addEventListener('click',()=>{
        form.reset();hideResult();error.hidden=true;
        inputs.forEach(input=>input.removeAttribute('aria-invalid'));
        status.textContent='Calculator reset. Enter your birth dates to begin again.';
        chooser.scrollIntoView({block:'start',behavior:'instant'});inputs[0].focus({preventScroll:true});
      });
      result.append(reset);chooser.hidden=true;result.hidden=false;result.classList.add('is-visible');
      status.textContent=`Result ready. Compatibility number ${reading.number}, five illustrated chapters.`;
      requestAnimationFrame(()=>{
        heading.focus({preventScroll:true});result.scrollIntoView({block:'start',behavior:'instant'});
        if ('IntersectionObserver' in window) {
          observer=new IntersectionObserver(entries=>{
            if(entries.some(entry=>entry.isIntersecting)) openOffer();
          },{rootMargin:'0px 0px -8% 0px',threshold:0});
          observer.observe(endMarker);
        }
      });
    });
  });
}());
